import { Domain, VolunteerActivism, LocationOn, Bed, PermMedia } from '@mui/icons-material';

export enum ToggleActions {
  Config = 'config',
}

export enum HotelStatus {
  managed = 'managed',
  outdated = 'outdated',
  toReview = 'toReview',
}

export enum HotelInfoDefaultSource {
  Description = 'description',
  Location = 'location',
  Rooms = 'rooms',
  Images = 'images',
  Amenities = 'amenities',
}

export const hotelInfoDefaultSourceList = [
  {
    id: HotelInfoDefaultSource.Description,
    name: 'hotels.contentManager.configuration.defaultValues.description',
    icon: Domain,
  },
  {
    id: HotelInfoDefaultSource.Location,
    name: 'hotels.contentManager.configuration.defaultValues.location',
    icon: LocationOn,
  },
  { id: HotelInfoDefaultSource.Rooms, name: 'hotels.contentManager.configuration.defaultValues.rooms', icon: Bed },
  {
    id: HotelInfoDefaultSource.Images,
    name: 'hotels.contentManager.configuration.defaultValues.images',
    icon: PermMedia,
  },
  {
    id: HotelInfoDefaultSource.Amenities,
    name: 'hotels.contentManager.configuration.defaultValues.amenities',
    icon: VolunteerActivism,
  },
];
